import { DATE_FORMATS } from '~/constants';
import date from '~/utils/date';

const DEFAULT_DATE_VALUE = '-';

/**
 * Composable for date formatting utilities
 */
export default function useDateFormat() {
  const formatDate = (dateString?: string): string => {
    if (!dateString) return DEFAULT_DATE_VALUE;
    return date(dateString).format(DATE_FORMATS.DATE);
  };

  return {
    formatDate,
  };
}
